import React, { Component } from "react";
import TitleBar from '../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';
import NavigationBar from '../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import WorkorderTab from './WorkorderTabSystem';
import { connect } from 'react-redux';
import InactiveWindow from '../../Logout/InActive';
import Idle from 'react-idle';
import { Modal } from 'reactstrap';
import classnames from 'classnames';

class Workorder extends Component {
    componentWillMount() {
        var PMMailDetails = localStorage.getItem('mailPMId');
        if (PMMailDetails !== undefined && PMMailDetails !== null && PMMailDetails !== "null" && PMMailDetails !== "") {
            sessionStorage.setItem('activeContent', 2);
        } else {
            sessionStorage.setItem('activeContent', 1);
        }
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            inactive_modal: false,
            LogOffTime: 1200000
        }
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
    }

    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.Inactivetoggle();
    }

    render(OnPremises) {
        let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        console.log('ensemble logoff time'+this.state.LogOffTime);
        return (
            <div className="Ensemble">
                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({
                            inactive_modal: true
                        });
                    }
                }} />
                {
                    !IsOnPremise ?
                        <div>
                            <NavigationBar />
                            <TitleBar parentToChildData={"Work Order Management"} istabView={true} />
                            <div className="Ensemble_Content margin_top">
                                <WorkorderTab />
                            </div>
                            <Footer />
                        </div> : <div className="Ensemble_Content_FullPage"><WorkorderTab /></div>
                }
                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={classnames({ classnames: this.props.className }, "ModalContainer InActive_Short_Modal")} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};
export default connect(mapStateToProps, null)(Workorder);